import { createRequestTypes } from '../utils';

export const INIT = 'referentials/INIT';
export const ALL_REFERENTIALS = createRequestTypes('referentials/ALL');
export const LIST_COUNTRY = createRequestTypes('referentials/LIST_COUNTRY');
